import { AuthBranding } from './AuthBranding';
import type { ReactNode } from 'react';
import { AuthContainerWrapper, AuthCard } from './styled';

export interface AuthContainerProps {
  children: ReactNode;
}

/**
 * Main container component for authentication forms.
 *
 * @component
 * @example
 * ```tsx
 * <AuthContainer>
 *   <AuthHeader title="Sign In" />
 *   <form>...</form>
 * </AuthContainer>
 * ```
 *
 * @param {ReactNode} children - Form content
 */
export function AuthContainer({ children }: AuthContainerProps) {
  return (
    <AuthContainerWrapper>
      <AuthCard>{children}</AuthCard>
      <AuthBranding />
    </AuthContainerWrapper>
  );
}
